module.exports = __webpack_public_path__ + "static/media/10.faa50cf9.JPG";